<template>
  <div class="admin">
    <div class="adminSideBar">
      <sidebar-menu  :class="{noSidebar : isSidebar}"/>
    </div>
    <div class="admin__main container-router">
      <router-view />
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar/Desktop"

export default {
  name: 'adx-admin',
  components: {
    'sidebar-menu': SideBar
  },
  props: {

  },
  data() {
    return {
      
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
   
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  },
  computed: {
    isSidebar(){
      const routerName = this.$route.name

      if(routerName == 'terminal'){
        return true
      }
      return false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>